import { api } from '@/api'
import { useQuery } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { Worker } from './models'

export const useFetchWorkers = (showArchived: boolean = false, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['useFetchWorkers', showArchived],
    queryFn: () => api.get(`/user/workers${showArchived ? '' : '?isArchived=false'}`) as Promise<Worker[]>,
    select: (data = []) => {
      data.sort((a, b) => dayjs(b?.metadata?.lastTimeActive).unix() - dayjs(a?.metadata?.lastTimeActive).unix())
      return data
    },
    enabled
  })
}
